import { render, staticRenderFns } from "./ComboItem.vue?vue&type=template&id=096d4aff&scoped=true&"
import script from "./ComboItem.vue?vue&type=script&lang=js&"
export * from "./ComboItem.vue?vue&type=script&lang=js&"
import style0 from "./ComboItem.vue?vue&type=style&index=0&id=096d4aff&prod&scoped=true&lang=css&"
import style1 from "./ComboItem.vue?vue&type=style&index=1&id=096d4aff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096d4aff",
  null
  
)

export default component.exports